import React, { useState, useEffect } from 'react';
import SearchBar from './Components/SearchBar';
import destData from './dest.json';
import Map from './Components/Map';
import Directions from './Components/Directions';

function App() {
  const [dest, setDest] = useState("")
  const [directions, setDirections] = useState(null)
  const [init, setInit] = useState(false)
  const [lat, setLat] = useState(0)
  const [lng, setLng] = useState(0)
  
  useEffect(() => {
    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-height', `${window.innerHeight}px`);
    }

    window.addEventListener('resize', appHeight);
    appHeight();

    getGeolocation()

    return () => {
      window.removeEventListener('resize', appHeight)
    }
  }, [])

  useEffect(() => {
    if (dest.split(' ').length === 1) return;

    const directionsService = new global.google.maps.DirectionsService();

    const origin = { lat: lat, lng: lng }; 
    const destination = dest.split(' ')[0];

    directionsService.route(
      {
        origin: origin,
        destination: {placeId: destination},
        travelMode: global.google.maps.TravelMode.BICYCLING,
      },
      (result, status) => {
        if (status === global.google.maps.DirectionsStatus.OK) {
          setDirections(result)
        } else {
          console.error(`error fetching directions ${result}`);
        }
      }
    );
  }, [dest])

  const findDest = (id) => {
    console.log(id);
    setDest(`${id} ${new Date().getMilliseconds()}`);
  }
  const getGeolocation = () => {
    navigator.geolocation.getCurrentPosition(location => {
      setLat(location.coords.latitude)
      setLng(location.coords.longitude)
      setInit(true)
    });
  }

  if (!init) {
    return <h1>Enable location services and refresh</h1>
  }

  return (
    <div>
      <SearchBar placeholder={"Search"} data={destData} searchDest={findDest}/>
      <Map lat={lat} lng={lng} directions={directions} />
      <Directions 
        lat={lat}
        lng={lng}
        dest={dest}
      />
    </div>
  );
}

export default App;